(function() {
    'use strict';

    angular
        .module('app')
        .directive('focusSearch', focusSearch);

    focusSearch.$inject = ['$window'];
    
    function focusSearch ($window) {
        // Usage:
        //     <focusSearch></focusSearch>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope, element, attrs) {
            scope.focusSearch = function () {
                element[0].focus();
            }
        }
    }

})();